import React from "react"
import styled from "styled-components"

const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  //position: absolute;
  overflow: hidden;

  video {
    width: 100%;
    height: auto;
  }
`

const Video = ({ videoSrcURL, videoTitle, ...props }) => (
  <VideoWrapper>
    <video autoPlay={true} muted={true} loop={true} id="myVideo">
      <source src={videoSrcURL} type="video/mp4" />
      Your browser does not support HTML5 video.
    </video>
  </VideoWrapper>
)
export default Video
